export default __webpack_public_path__ + "static/media/closepair.64935cf2.png";